import React, { useEffect, useState } from "react";
import { ValidatorForm } from "react-form-validator-core";
import Header from "../../layout/Header";
import TextValidator from "../../partial/TextValidator";
import TextAreaValidator from "../../partial/TextAreaValidator";
import { QueryBuilder, formatQuery } from "react-querybuilder";
import "react-querybuilder/dist/query-builder.css";
import swal from "sweetalert";
import SelectValidator from "../../partial/SelectValidator";
import Switch from "react-switch";
import { getOperator, selectValueGetter } from "../../../utils/helper";
import { decrypt } from "../../../utils/encodingdecoding";
import { getTierById, schema, updateTier } from "../campaigns/services";
import { createTier } from "../../../actions/auth";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { backIcon2 } from "../../../Image/Index";

function Tiers() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const codeId = location.state || id;
  const [loader, setLoader] = useState(false);
  const initialQueryUE = {
    combinator: "and",
    rules: [],
    sqlFilter: "",
  };
  const initialQueryUF = {
    combinator: "and",
    rules: [],
  };
  const initialQueryDE = {
    combinator: "and",
    rules: [],
    sqlFilter: "",
  };
  const initialQueryDF = {
    combinator: "and",
    rules: [],
  };
  // const [clientOption, setClientOption] = useState([{ value: "merchant", label: "merchant", }])
  // const [schemaOpt, setSchemaOpt] = useState([{ value: "sanity 220", label: "sanity", }])
  const [durationOpt, setDurationOpt] = useState([
    { value: "15Day", label: "15 Day" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Monthly", label: "Monthly" },
  ]);

  const operatorMapping = [
    { name: "equal", label: "Equal", operator: "=" },
    { name: "not_equal", label: "Not Equal", operator: "!=" },
    { name: "less", label: "Less", operator: "<" },
    { name: "less_or_equal", label: "Less Or Equal", operator: "<=" },
    { name: "greater", label: "Greater", operator: ">" },
    { name: "greater_or_equal", label: "Greater Or Equal", operator: ">=" },
    { name: "between", label: "Between", operator: "between" },
  ];

  const levelOpt = [
    { label: 1, value: "1" },
    { label: 2, value: "2" },
    { label: 3, value: "3" },
    { label: 4, value: "4" },
    { label: 5, value: "5" },
    { label: 6, value: "6" },
    { label: 7, value: "7" },
    { label: 8, value: "8" },
    { label: 9, value: "9" },
    { label: 10, value: "10" },
  ];

  const initialState = {
    name: "",
    code: "",
    level: "",
    durationfieldName: "",
    client: "",
    status: false,
    alert: false,
    tags: "",
    description: "",
    assignTier: false,
    retentionRule: false,
    assignTierValue: "",
    upgradeToggle: false,
    downgradeToggle: false,
    upgradeDuration: "",
    downgradeDuration: "",
    upgradeRule: [
      {
        id: 1,
        existingRule: initialQueryUE,
        functionRule: initialQueryUF,
      },
    ],
    downgradeRule: [
      {
        id: 1,
        existingRule: initialQueryDE,
        functionRule: initialQueryDF,
      },
    ],
  };
  const [state, setState] = useState(initialState);

  const [data, setData] = useState();
  const [functionRule, setFunctionRule] = useState();
  const [durationTransaction, setDurationTransaction] = useState();
  const [transSchema, setTransSchema] = useState();
  const {
    name,
    code,
    client,
    status,
    alert,
    description,
    upgradeRule,
    retentionRule,
    downgradeRule,
    assignTier,
    upgradeToggle,
    downgradeToggle,
    assignTierValue,
    upgradeDuration,
    level,
    durationfieldName,
    downgradeDuration,
  } = state;

  const fields =
    data?.length > 0 &&
    data?.map((item) => {
      if (item?.fielddatatype === "Enumeration") {
        return {
          name: item?.key,
          label: item?.fielddisplayname,
          type: item?.type,
          valueEditorType: "select",
          values: [
            { value: "", label: "Select", key: "select-option" },
            ...item?.enum.map((i, index) => ({
              value: i,
              label: i,
              key: index,
            })),
          ],
        };
      } else {
        return {
          name: item?.key,
          label: item?.fielddisplayname,
          type: item?.type,
        };
      }
    });

  const fieldsRule =
    functionRule?.length > 0 &&
    functionRule?.map((item) => {
      return {
        name: item?.value,
        label: item?.label,
        type: item?.type,
      };
    });
  const fetchSchema = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    let schemaName = localStorage.getItem("schemaName");
    schemaName = schemaName.split(" ").join("");
    const response = await schema(token?.access_token, schemaName);
    if (response.message === "Request processed successfully.") {
      let newdata = response?.data?.schema?.properties;
      let temp = [];
      let tempExisTrans = [];
      let tempExis = [];
      let flag = 1;
      for (const property in newdata) {
        if (
          property === "transactionDate" ||
          newdata[property]?.isrulesupported === true ||
          newdata[property]?.isRuleSupported === true
        ) {
          if (newdata[property].fielddatatype === "Enumeration") {
            temp.push({
              key: property,
              fielddisplayname: newdata[property]?.fielddisplayname,
              type: newdata[property]?.type,
              enum: newdata[property]?.enum,
              fielddatatype: newdata[property]?.fielddatatype,
            });
          } else {
            temp.push({
              key: property,
              fielddisplayname: property,
              type: newdata[property]?.type,
            });
          }

          if (
            !tempExisTrans.some(
              (item) =>
                item.label === "TransactionCount" &&
                item.value === "TransactionCount",
            )
          ) {
            tempExis.push({
              label: "TransactionCount",
              value: "TransactionCount",
              type: "number",
              fielddatatype: "Number",
            });
          }

          if (
            (newdata[property]?.isrulesupported === true ||
              newdata[property]?.isRuleSupported === true) &&
            newdata[property].type === "number"
          ) {
            tempExis.push({
              label: property,
              value: property,
              index: flag,
              type: newdata[property]?.type,
              fielddatatype: newdata[property]?.fielddatatype,
            });
          }
        }

        flag += 1;
        if (
          newdata[property]?.isTransactionDate === true ||
          property === "transactionDate"
        ) {
          tempExisTrans.push({
            label: newdata[property]?.fielddisplayname,
            value: property,
            index: flag,
            type: newdata[property]?.type,
            fielddatatype: newdata[property]?.fielddatatype,
          });
        }
      }
      setTransSchema(response?.data?.transactionSchemaCode);
      setData(temp);
      setDurationTransaction([
        // { value: "", label: "Select" },
        ...tempExisTrans,
      ]);
      setFunctionRule(tempExis);
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchSchema();
  }, []);

  useEffect(() => {
    if (codeId) {
      setLoader(true);
      const token = JSON.parse(localStorage.getItem("token_gen"));
      const response = getTierById(token?.access_token, id);
      response
        .then((res) => {
          if (res.message === "Request processed successfully.") {
            const { data } = res;
            setState((prev) => ({
              ...prev,
              name: data?.name,
              code: data?.code,
              level: data?.level,
              durationfieldName: data?.durationfieldName,
              status: data?.status,
              alert: data?.alert,
              description: data?.description,
              retentionRule: data?.retentionvalue,
              assignTier: data?.filter?.upgradeRule?.assignTier,
              assignTierValue: data?.filter?.upgradeRule?.assignTierValue,
              upgradeDuration: data?.filter?.upgradeRule?.duration,
              upgradeToggle: data?.filter?.upgradeRule?.durationStatus,
              downgradeDuration: data?.filter?.degradeRule?.duration,
              downgradeToggle: data?.filter?.degradeRule?.durationStatus,
              upgradeRule: data?.filter?.upgradeRule?.rules?.map(
                (ele, ind) => ({
                  id: ind + 1,
                  existingRule: {
                    combinator: ele?.existingRule?.condition,
                    rules: ele?.existingRule?.rules,
                    sqlFilter: ele?.sqlFilter,
                  },
                  functionRule: {
                    combinator: ele?.functionRule?.condition,
                    rules: ele?.functionRule?.rules,
                  },
                }),
              ),
              downgradeRule: data?.filter?.degradeRule?.rules?.map(
                (ele, ind) => ({
                  id: ind + 1,
                  existingRule: {
                    combinator: ele?.existingRule?.condition,
                    rules: ele?.existingRule?.rules,
                    sqlFilter: ele?.sqlFilter,
                  },
                  functionRule: {
                    combinator: ele?.functionRule?.condition,
                    rules: ele?.functionRule?.rules,
                  },
                }),
              ),
            }));
          }
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
        });
    }
  }, [location]);

  useEffect(() => {
    if (!upgradeToggle) {
      setState((prev) => ({
        ...prev,
        upgradeDuration: "",
      }));
    }

    if (!assignTier) {
      setState((prev) => ({
        ...prev,
        assignTierValue: "",
      }));
    }

    if (!downgradeToggle) {
      setState((prev) => ({
        ...prev,
        downgradeDuration: "",
      }));
    }

    if (!retentionRule) {
      setState((prev) => ({
        ...prev,
        downgradeToggle: false,
        downgradeDuration: "",
        downgradeRule: [
          {
            id: 1,
            existingRule: initialQueryDE,
            functionRule: initialQueryDF,
          },
        ],
      }));
    }
  }, [upgradeToggle, assignTier, downgradeToggle, retentionRule]);

  function manipulateQuery(newQuery) {
    const transformRules = (rules, flag) => {
      return rules.map((rule) => {
        if (rule.rules) {
          return {
            condition: rule.combinator ? rule.combinator.toUpperCase() : "AND",
            rules: transformRules(rule.rules),
          };
        } else {
          let selectedFieldOp;

          selectedFieldOp = operatorMapping.find(
            (item) => item?.value === rule.operator,
          )?.value;

          if (!selectedFieldOp) {
            selectedFieldOp = operatorMapping.find(
              (item) => item.name === rule.operator,
            )?.name;
          }

          let tempType;
          fields?.filter((f) => {
            if (f.name === rule.field) {
              tempType = f.type;
            } else {
              if (rule?.field === "TransactionCount") {
                tempType = "number";
              }
            }
          });
          return {
            id: rule.field === "TransactionCount" ? "Functions" : "Sum",
            field: rule.field,
            type: tempType,
            input:
              tempType === "string" || tempType === "boolean"
                ? "text"
                : "number",
            operator: selectedFieldOp,
            value:
              tempType === "string" || tempType === "boolean"
                ? rule.value
                : Array.isArray(rule.value)
                  ? rule.value
                  : typeof rule.value === "string" && rule.value.includes(",")
                    ? rule.value.split(",").map(Number)
                    : Number(rule.value),
            data:
              flag === "existing"
                ? {
                    class: "Customer",
                  }
                : {
                    class: null,
                  },
          };
        }
      });
    };

    const transformedQuery = newQuery?.map((ele) => {
      const { id, existingRule, functionRule, sqlFilter, ...rest } = ele;
      return {
        ...rest,
        existingRule: {
          condition: ele.combinator ? ele.combinator.toUpperCase() : "AND",
          rules: transformRules(existingRule.rules, "existing"),
        },
        functionRule: {
          condition: ele.combinator ? ele.combinator.toUpperCase() : "AND",
          rules: transformRules(functionRule.rules, "function"),
        },
        sqlFilter: sqlFilter ? sqlFilter : existingRule?.sqlFilter,
      };
    });

    return transformedQuery;
  }

  function manipulateSqlRule(newQuery) {
    const transformRules = (rules) => {
      return rules?.map((rule) => {
        if (rule.rules) {
          return {
            rules: transformRules(rule.rules),
          };
        } else {
          let tempType;
          fields?.filter((f) => {
            if (f.name === rule.field) {
              tempType = f.type;
            }
          });
          let tempOp;
          operatorMapping?.filter((op) => {
            if (op.name === rule.operator) {
              tempOp = op.operator;
            }
          });
          return {
            id: rule.field,
            field: `c.transactionDetail.${rule.field}`,
            type: tempType,
            input:
              tempType === "string" || tempType === "boolean"
                ? "text"
                : "number",
            operator: tempOp,
            value:
              tempType === "string" || tempType === "boolean"
                ? rule.value
                : Array.isArray(rule.value)
                  ? rule.value
                  : typeof rule.value === "string" && rule.value.includes(",")
                    ? rule.value.split(",").map(Number)
                    : Number(rule.value),
            data: {
              class: "Customer",
            },
          };
        }
      });
    };

    return {
      ...newQuery,
      rules: transformRules(newQuery.rules),
    };
  }

  const handleQueryChange = (newQuery, id, rule, type) => {
    const manipulatedSqlRule = manipulateSqlRule(newQuery);
    const sqlWhere = formatQuery(manipulatedSqlRule, "sql");
    if (rule === "upgrade") {
      if (type === "existing") {
        setState((prev) => ({
          ...prev,
          upgradeRule: prev.upgradeRule.map((ele) => {
            if (ele.id === id) {
              return {
                ...ele,
                sqlFilter: sqlWhere,
                existingRule: newQuery,
              };
            } else return ele;
          }),
        }));
      } else {
        setState((prev) => ({
          ...prev,
          upgradeRule: prev.upgradeRule.map((ele) => {
            if (ele.id === id) {
              return {
                ...ele,
                functionRule: newQuery,
              };
            } else return ele;
          }),
        }));
      }
    } else {
      if (type === "existing") {
        setState((prev) => ({
          ...prev,
          downgradeRule: prev.downgradeRule.map((ele) => {
            if (ele.id === id) {
              return {
                ...ele,
                sqlFilter: sqlWhere,
                existingRule: newQuery,
              };
            } else return ele;
          }),
        }));
      } else {
        setState((prev) => ({
          ...prev,
          downgradeRule: prev.downgradeRule.map((ele) => {
            if (ele.id === id) {
              return {
                ...ele,
                functionRule: newQuery,
              };
            } else return ele;
          }),
        }));
      }
    }
  };

  const handleChange = (e) => {
    setState({
      ...state,
      ...{ [e.target.name]: e.target.value.replace(/^\s+/, "") },
    });
  };

  const onSelectChange = (e, selectFor) => {
    setState({ ...state, [selectFor]: e.value });
  };

  const handleToggle = (e, name) => {
    setState({ ...state, [name]: e.target.checked });
  };

  const handleAddItem = (type) => {
    if (type === "upgrade") {
      setState((prev) => ({
        ...prev,
        upgradeRule: prev.upgradeRule.length > 0 && [
          ...prev.upgradeRule,
          {
            id: prev.upgradeRule[prev.upgradeRule.length - 1].id + 1,
            existingRule: initialQueryUE,
            functionRule: initialQueryUF,
          },
        ],
      }));
    } else {
      setState((prev) => ({
        ...prev,
        downgradeRule: prev.downgradeRule.length > 0 && [
          ...prev.downgradeRule,
          { id: prev.downgradeRule[prev.downgradeRule.length - 1].id + 1 },
        ],
      }));
    }
  };

  const handleDeleteItem = (id, type) => {
    if (type === "upgrade") {
      setState((prev) => ({
        ...prev,
        upgradeRule: prev.upgradeRule.filter((ele) => ele.id !== id),
      }));
    } else {
      setState((prev) => ({
        ...prev,
        downgradeRule: prev.downgradeRule.filter((ele) => ele.id !== id),
      }));
    }
  };
  const onSubmit = async () => {
    const upgradeQuery = manipulateQuery(upgradeRule);
    const downgradeQuery = manipulateQuery(downgradeRule);
    const body = {
      name: name,
      code: codeId ? code : null,
      level: level,
      durationfieldName: durationfieldName,
      merchantcode: decrypt(localStorage.getItem("Id")),
      alert: alert,
      status: status,
      retentionvalue: retentionRule,
      description: description,
      tags: [],
      schemaCode: transSchema,
      filter: {
        upgradeRule: {
          durationStatus: upgradeToggle,
          assignTier: assignTier,
          assignTierValue: assignTierValue,
          duration: upgradeDuration,
          rules: upgradeQuery,
        },
        degradeRule: {
          durationStatus: downgradeToggle,
          duration: downgradeDuration,
          rules: downgradeQuery,
        },
      },
    };

    const token = JSON.parse(localStorage.getItem("token_gen"));

    if (!codeId) {
      setLoader(true);
      const res = await createTier(token?.access_token, body);
      if (res?.message === "Request processed successfully.") {
        swal({
          position: "center",
          icon: "success",
          title: "Tier created successfully",
          showConfirmButton: false,
          timer: 5000,
        });
        setState(initialState);
        setLoader(false);
        navigate("/getTiers");
      } else {
        swal({
          position: "center",
          icon: "error",
          title: res.message,
          showConfirmButton: false,
          timer: 5000,
        });
        setLoader(false);
      }
    } else {
      setLoader(true);
      const id = decrypt(localStorage.getItem("Id"));
      const res = await updateTier(token?.access_token, id, body);
      if (res?.message === "Request processed successfully.") {
        swal({
          position: "center",
          icon: "success",
          title: "Tier updated successfully",
          showConfirmButton: false,
          timer: 5000,
        });
        setState(initialState);
        setLoader(false);
        navigate("/getTiers");
      } else {
        swal({
          position: "center",
          icon: "error",
          title: res.message,
          showConfirmButton: false,
          timer: 5000,
        });
        setLoader(false);
      }
    }
  };

  return (
    <div>
      <Header name={"Tiers"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="dashboard__heading">
          <div className="dashboard__headingLeft">
            <div className="dashboard__headingBackLink">
              <Link to="" onClick={() => navigate(-1)}>
                <img src={backIcon2} alt="" />
                <div className="dashboard__headingContent">
                  <h3>Tier</h3>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <ValidatorForm
          onSubmit={onSubmit}
          className="dashboard__customerViewMain"
        >
          <div className="dashboard__transactionsCard">
            <div className="dashboard__customerViewCard">
              <div className="row">
                <div className="query_builder_box">
                  <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                      <div className="form-group">
                        <label>Tiers Name</label>
                        <TextValidator
                          type="text"
                          value={name}
                          onChange={handleChange}
                          placeholder="Tiers Name"
                          className="form-control"
                          maxLength="20"
                          name="name"
                          validators={["required"]}
                          errorMessages={["Please enter tier name"]}
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                      <div className="form-group">
                        <label>Priority</label>
                        <SelectValidator
                          placeholder="Select level"
                          className="custom-ReactSelect bordered"
                          name="level"
                          value={selectValueGetter(levelOpt, level)}
                          options={levelOpt}
                          onChange={(e) => onSelectChange(e, "level")}
                          validators={["required"]}
                          errorMessages={["Please select level"]}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                      <div className="form-group">
                        <label>Duration Field</label>
                        <SelectValidator
                          placeholder="Select Duration Field"
                          className="custom-ReactSelect bordered"
                          name="durationfieldName"
                          value={selectValueGetter(
                            durationTransaction,
                            durationfieldName,
                          )}
                          options={durationTransaction}
                          onChange={(e) =>
                            onSelectChange(e, "durationfieldName")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group withIcon">
                                                <label>Client</label>
                                                <SelectValidator placeholder="Select Client"
                                                    className="custom-ReactSelect bordered"
                                                    name="client"
                                                    value={selectValueGetter(clientOption, client)}
                                                    options={clientOption}
                                                    onChange={(e) => onSelectChange(e, "client")}
                                                    validators={["required"]}
                                                    errorMessages={["Please select client"]} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group withIcon">
                                                <label>Transaction Schema</label>
                                                <SelectValidator placeholder="Select Client"
                                                    className="custom-ReactSelect bordered"
                                                    name="transactionSchema"
                                                    value={selectValueGetter(schemaOpt, transactionSchema)}
                                                    options={schemaOpt}
                                                    onChange={(e) => onSelectChange(e, "transactionSchema")}
                                                    validators={["required"]}
                                                    errorMessages={["Please select transaction schema"]} />
                                            </div>
                                        </div> */}
                  </div>

                  <div className="row voucher_box_row">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                      <div
                        className="person h40"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <p
                          className="voucher"
                          style={{
                            display: "flex",
                            width: "100%",
                            marginBottom: "0",
                            color: "black",
                          }}
                        >
                          Status
                        </p>
                        <div className="">
                          <label className="toggle mb-0">
                            <input
                              type="checkbox"
                              name="status"
                              checked={status}
                              onChange={(e) => handleToggle(e, "status")}
                            />
                            <span className="slider"></span>
                            <span
                              className="labels"
                              data-on="true"
                              data-off="false"
                            ></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <label>
                                                <strong className='d-block mb-3'>Status: </strong>
                                                <Switch name="status" checked={status} onChange={(e) => handleToggle(e, "status")} onColor={status ? "#50BC14" : "#E50000"} onHandleColor="#50BC14" handleDiameter={30} uncheckedIcon={true} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" />
                                            </label>
                                        </div> */}
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                      <div
                        className="person h40"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <p
                          className="voucher"
                          style={{
                            display: "flex",
                            width: "100%",
                            marginBottom: "0",
                            color: "black",
                          }}
                        >
                          Alert
                        </p>
                        <div className="">
                          <label className="toggle mb-0">
                            <input
                              type="checkbox"
                              name="alert"
                              checked={alert}
                              onChange={(e) => handleToggle(e, "alert")}
                            />
                            <span className="slider"></span>
                            <span
                              className="labels"
                              data-on="true"
                              data-off="false"
                            ></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <label>
                                                <strong className='d-block mb-3'>Alert:</strong>
                                                <Switch name="alert" checked={alert} onChange={(e) => handleToggle(e, "alert")} onColor={alert ? "#50BC14" : "#E50000"} onHandleColor="#50BC14" handleDiameter={30} uncheckedIcon={true} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" />
                                            </label>
                                        </div> */}
                  </div>
                  <div className="row mt-2">
                    {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group withIcon">
                                                <label>Tags</label>
                                                <TextValidator type="text"
                                                    value={tags}
                                                    onChange={handleChange}
                                                    placeholder="Tags"
                                                    className="form-control"
                                                    maxLength="20"
                                                    name="tags"
                                                    validators={["required"]}
                                                    errorMessages={["Please enter tags"]} />
                                            </div>
                                        </div> */}
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div className="form-group withIcon">
                        <label>Description</label>
                        <TextAreaValidator
                          type="text"
                          maxLength="100"
                          value={description}
                          onChange={handleChange}
                          placeholder="Description"
                          className="form-control"
                          name="description"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="form-group withIcon">
                    <div className="dashboard__header">
                      <div className="dashboard__left">
                        <h4 id="transction_list">Upgrade Rule</h4>
                      </div>
                      <button
                        type="button"
                        onClick={() => handleAddItem("upgrade")}
                        className="btn btn-success"
                      >
                        + Add Item
                      </button>
                    </div>
                    <div className="dashboard__body border">
                      {upgradeRule?.length > 0 &&
                        upgradeRule.map((ele) => {
                          return (
                            <div className="card p-3 mb-3" key={ele.id}>
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0">Existing Rule</h6>
                                {ele.id > 1 && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleDeleteItem(ele.id, "upgrade")
                                    }
                                    className="btn btn-danger"
                                  >
                                    Delete
                                  </button>
                                )}
                              </div>

                              <QueryBuilder
                                fields={fields}
                                operators={operatorMapping}
                                query={ele.existingRule}
                                onQueryChange={(newQuery) =>
                                  handleQueryChange(
                                    newQuery,
                                    ele.id,
                                    "upgrade",
                                    "existing",
                                  )
                                }
                                controlElements={{
                                  addGroup: false,
                                  addRule: true,
                                  removeRule: true,
                                  removeGroup: false,
                                }}
                              ></QueryBuilder>
                              <div className="d-flex justify-content-between align-items-center mb-2 mt-3">
                                <h6 className="mb-0"> Function Rule</h6>
                              </div>

                              <QueryBuilder
                                fields={fieldsRule}
                                query={ele.functionRule}
                                operators={operatorMapping}
                                onQueryChange={(newQuery) =>
                                  handleQueryChange(
                                    newQuery,
                                    ele.id,
                                    "upgrade",
                                    "function",
                                  )
                                }
                              ></QueryBuilder>
                            </div>
                          );
                        })}
                      <div className="row mb-2">
                        {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                    <label>
                                                        Duration:
                                                        <Switch name="upgradeToggle" checked={upgradeToggle} onChange={(e) => handleToggle(e, "upgradeToggle")} onColor={upgradeToggle ? "#50BC14" : "#E50000"} onHandleColor="#50BC14" handleDiameter={30} uncheckedIcon={true} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" />
                                                    </label>
                                                </div> */}

                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                          <div
                            className="person h40"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <p
                              className="voucher"
                              style={{
                                display: "flex",
                                width: "100%",
                                marginBottom: "0",
                                color: "black",
                              }}
                            >
                              Duration
                            </p>
                            <div className="">
                              <label className="toggle mb-0">
                                <input
                                  type="checkbox"
                                  name="upgradeToggle"
                                  checked={upgradeToggle}
                                  onChange={(e) =>
                                    handleToggle(e, "upgradeToggle")
                                  }
                                />
                                <span className="slider"></span>
                                <span
                                  className="labels"
                                  data-on="true"
                                  data-off="false"
                                ></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        {upgradeToggle && (
                          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <div
                              className="person h40"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <p
                                className="voucher"
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  marginBottom: "0",
                                  color: "black",
                                }}
                              >
                                Days
                              </p>
                              {/* <SelectValidator placeholder="Select Duration"
                                                            className="custom-ReactSelect bordered"
                                                            name="upgradeDuration"
                                                            value={selectValueGetter(durationOpt, upgradeDuration)}
                                                            options={durationOpt}
                                                            onChange={(e) => onSelectChange(e, "upgradeDuration")}
                                                            validators={["required"]}
                                                            errorMessages={["Please select Duration"]} /> */}
                              <TextValidator
                                className="form-control"
                                validators={["required"]}
                                errorMessages={[" Enter Days"]}
                                name="upgradeDuration"
                                value={upgradeDuration}
                                placeholder="Enter Days"
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                          <div
                            className="person h40"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <p
                              className="voucher"
                              style={{
                                display: "flex",
                                width: "100%",
                                marginBottom: "0",
                                color: "black",
                              }}
                            >
                              Tier Assign Duration
                            </p>
                            <div className="">
                              <label className="toggle mb-0">
                                <input
                                  type="checkbox"
                                  name="assignTier"
                                  checked={assignTier}
                                  onChange={(e) =>
                                    handleToggle(e, "assignTier")
                                  }
                                />
                                <span className="slider"></span>
                                <span
                                  className="labels"
                                  data-on="true"
                                  data-off="false"
                                ></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                    <label>
                                                        Tier Assign Duration:
                                                        <Switch name="assignTier" checked={assignTier} onChange={(e) => handleToggle(e, "assignTier")} onColor={assignTier ? "#50BC14" : "#E50000"} onHandleColor="#50BC14" handleDiameter={30} uncheckedIcon={true} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" />
                                                    </label>
                                                </div> */}

                        {assignTier && (
                          // <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                          //     <div className="form-group withIcon mb-0">
                          //         <SelectValidator placeholder="Select Assign Tier Duration"
                          //             className="custom-ReactSelect bordered"
                          //             name="assignTierValue"
                          //             value={selectValueGetter(durationOpt, assignTierValue)}
                          //             options={durationOpt}
                          //             onChange={(e) => onSelectChange(e, "assignTierValue")}
                          //             validators={["required"]}
                          //             errorMessages={["Please select Assign tier duration"]} />
                          //     </div>
                          // </div>
                          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <div
                              className="person h40"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <p
                                className="voucher"
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  marginBottom: "0",
                                  color: "black",
                                }}
                              >
                                Days
                              </p>
                              <TextValidator
                                className="form-control"
                                validators={["required"]}
                                errorMessages={[" Enter Days"]}
                                name="assignTierValue"
                                value={assignTierValue}
                                placeholder="Enter Days"
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                          <div
                            className="person h40"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <p
                              className="voucher"
                              style={{
                                display: "flex",
                                width: "100%",
                                marginBottom: "0",
                                color: "black",
                              }}
                            >
                              Retention Rule
                            </p>
                            <div className="">
                              <label className="toggle mb-0">
                                <input
                                  type="checkbox"
                                  name="retentionRule"
                                  checked={retentionRule}
                                  onChange={(e) =>
                                    handleToggle(e, "retentionRule")
                                  }
                                />
                                <span className="slider"></span>
                                <span
                                  className="labels"
                                  data-on="true"
                                  data-off="false"
                                ></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {retentionRule && (
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="form-group withIcon">
                      <div className="dashboard__header">
                        <div className="dashboard__left">
                          <h4 id="transction_list">Retention Rule</h4>
                        </div>
                        <button
                          type="button"
                          onClick={() => handleAddItem("downgrade")}
                          className="btn btn-success"
                        >
                          + Add Item
                        </button>
                      </div>
                      <div className="dashboard__body border">
                        {downgradeRule?.length > 0 &&
                          downgradeRule.map((ele) => {
                            return (
                              <div className="card p-3 mb-3" key={ele.id}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h6 className="mb-0">Existing Rule</h6>
                                  {ele.id > 1 && (
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleDeleteItem(ele.id, "downgrade")
                                      }
                                      className="btn btn-danger"
                                    >
                                      Delete
                                    </button>
                                  )}
                                </div>

                                <QueryBuilder
                                  fields={fields}
                                  operators={operatorMapping}
                                  query={ele.existingRule}
                                  onQueryChange={(newQuery) =>
                                    handleQueryChange(
                                      newQuery,
                                      ele.id,
                                      "downgrade",
                                      "existing",
                                    )
                                  }
                                ></QueryBuilder>
                                <div className="d-flex justify-content-between align-items-center mb-2 mt-3">
                                  <h6 className="mb-0">Function Rule</h6>
                                </div>

                                <QueryBuilder
                                  fields={fieldsRule}
                                  operators={operatorMapping}
                                  query={ele.functionRule}
                                  onQueryChange={(newQuery) =>
                                    handleQueryChange(
                                      newQuery,
                                      ele.id,
                                      "downgrade",
                                      "function",
                                    )
                                  }
                                ></QueryBuilder>
                              </div>
                            );
                          })}
                        <div className="row">
                          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                            <div
                              className="person h40"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <p
                                className="voucher"
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  marginBottom: "0",
                                  color: "black",
                                }}
                              >
                                Duration
                              </p>
                              <div className="">
                                <label className="toggle mb-0">
                                  <input
                                    type="checkbox"
                                    name="downgradeToggle"
                                    checked={downgradeToggle}
                                    onChange={(e) =>
                                      handleToggle(e, "downgradeToggle")
                                    }
                                  />
                                  <span className="slider"></span>
                                  <span
                                    className="labels"
                                    data-on="true"
                                    data-off="false"
                                  ></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                    <label>
                                                        Duration:
                                                        <Switch name="downgradeToggle" checked={downgradeToggle} onChange={(e) => handleToggle(e, "downgradeToggle")} onColor={downgradeToggle ? "#50BC14" : "#E50000"} onHandleColor="#50BC14" handleDiameter={30} uncheckedIcon={true} checkedIcon={false} boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)" activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)" height={20} width={48} className="react-switch" />
                                                    </label>
                                                </div> */}
                          {downgradeToggle && (
                            // <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                            //     <div className="form-group withIcon mb-0">
                            //         <SelectValidator placeholder="Select Duration"
                            //             className="custom-ReactSelect bordered"
                            //             name="downgradeDuration"
                            //             value={selectValueGetter(durationOpt, downgradeDuration)}
                            //             options={durationOpt}
                            //             onChange={(e) => onSelectChange(e, "downgradeDuration")}
                            //             validators={["required"]}
                            //             errorMessages={["Please select transaction schema"]} />
                            //     </div>
                            // </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                              <div
                                className="person h40"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <p
                                  className="voucher"
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    marginBottom: "0",
                                    color: "black",
                                  }}
                                >
                                  Days
                                </p>
                                <TextValidator
                                  className="form-control"
                                  validators={["required"]}
                                  errorMessages={[" Enter Days"]}
                                  name="downgradeDuration"
                                  value={downgradeDuration}
                                  placeholder="Enter Days"
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="customer_group_form">
                <button type="submit" className="btn btn-primary">
                  {codeId ? "Update" : "Create"}
                </button>
                {/* {groupId ? (
                                       <button type='submit' className="btn btn-primary btn-lg">
                                       Update
                                   </button>
                                ) :(
                                    <button type='submit' className="btn btn-primary btn-lg">
                                    Create
                                </button>
                                ) } */}
              </div>
            </div>
          </div>
        </ValidatorForm>
      </div>
    </div>
  );
}

export default Tiers;
